import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { PushNotificationsService } from 'ng-push';

@Injectable()
export class NotificationToastService {
  constructor( private toastrService: ToastrService,
               private pushNotifications: PushNotificationsService) {
  }

  success(message: string, title: string) {
    this.toastrService.success(message, title);
  }


  error(message: string, title: string, disableTimeOut: boolean = false) {

     const config = {
      disableTimeOut: disableTimeOut,
      closeButton: disableTimeOut,
      enableHtml: false
    };


    this.toastrService.error(message, title, config);
  }

  info(message: string, title: string, disableTimeOut: boolean = false,
        closeButton: boolean = false, enableHtml: boolean = false): NotificationToastResponse {

    const config = {
      disableTimeOut: disableTimeOut,
      closeButton: closeButton,
      enableHtml: enableHtml
    };

    const toast = this.toastrService.info(message, title, config);
    // tslint:disable-next-line: no-use-before-declare
    const notificationToastResponse = new NotificationToastResponse();
    notificationToastResponse.onTap = toast.onTap;
    notificationToastResponse.toastId = toast.toastId;
    return notificationToastResponse;
  }

  pushNotificationRequestPermission() {
    this.pushNotifications.requestPermission();
  }

  sendPushNotification(message: any) {
    const options = {
      body: message,
      icon: 'Content/Images/banner-ico.png' // adding an icon
    };
    this.pushNotifications.create('Clayer', options).subscribe(// creates a notification
      // creates a notification
      res => console.log(res), err => console.log(err));
  }

  clear(toastId: number) {
     this.toastrService.clear(toastId);
  }
}


export class NotificationToastResponse {
  public onTap: Observable<any>;
  public toastId: number;
}
